import React from "react";
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

export const ModalSuspender = (props) => {

    const { mostrar, cerrar, nombreArchivoTxt,
        funcionSi, loteIdImss } = props;

    const footer = (
        <div>
            <Button label="Si" icon="pi pi-check" onClick={() => funcionSi()} />
            <Button label="No" icon="pi pi-times" onClick={() => cerrar()} />
        </div>
    );

    return (
        <div>
            <Dialog header="Liberar Lote" visible={mostrar} style={{ width: '50vw' }} modal={true}
                onHide={cerrar} footer={footer}>
                <h1>Liberar un lote</h1>
                <h3>Este procedimiento sucede cuando ya se cuenta con un número de lote del IMSS, sin embargo por alguna
                    razón de lógica de negocio se debe de volver a mandar el mismo archivo .TXT, le queremos informar que no es posible eliminar
                    el número de lote <strong>{loteIdImss}</strong> de nuestra base de datos, sin embargo podemos modificar la llave de integridad para que usted cargue
                    de nuevo el archivo <strong>{nombreArchivoTxt}</strong></h3>
                ¿Está usted seguro de liberar el archivo <strong>{nombreArchivoTxt}</strong> con el numero de lote <strong>{loteIdImss}</strong> asignado por el IMSS y todo lo relacionado con el mismo?,
                este proceso ya no puede revertirse, si está seguro dar click en <strong>Si</strong> de lo contrario elegir <strong>No</strong>
            </Dialog>
        </div>
    );
}